import { createReducer } from 'reduxsauce';
import {
  SET_SHOW_MORE_MENU,
  HIDE_SHOW_MORE_MENU,
  TOGGLE_SHOW_COMMUNITY_MENU,
  TOGGLE_SHOW_COMMUNITY_SELECT_MODAL,
  TOGGLE_MENTIONS_MODAL
} from '../../actions/ui/uiActions';

export const INITIAL_STATE = {
  // The comment id where
  // the 'show more' menu
  // is currently visible
  visibleMenuId: null,
  isVisibleCommunityMenu: false,
  isVisibleCommunitySelectModal: false,
  isVisibleMentionsModal: false
};

export const setShowMoreMenu = (state = INITIAL_STATE, action) => {
  const {
    payload: { visibleMenuId }
  } = action;

  return {
    ...state,
    visibleMenuId
  };
};

export const hideShowMoreMenu = (state = INITIAL_STATE) => ({
  ...state,
  visibleMenuId: null
});

export const toggleShowCommunityMenu = (state = INITIAL_STATE) => ({
  ...state,
  isVisibleCommunityMenu: !state.isVisibleCommunityMenu
});

export const toggleShowCommunitySelectModal = (
  state = INITIAL_STATE,
  action
) => {
  const { visible } = action.payload;
  return {
    ...state,
    isVisibleCommunitySelectModal: visible
  };
};

export const toggleMentionsModal = (state = INITIAL_STATE, action) => {
  const { visible } = action.payload;
  return {
    ...state,
    isVisibleMentionsModal: visible
  };
};

export default createReducer(INITIAL_STATE, {
  [SET_SHOW_MORE_MENU]: setShowMoreMenu,
  [HIDE_SHOW_MORE_MENU]: hideShowMoreMenu,
  [TOGGLE_SHOW_COMMUNITY_MENU]: toggleShowCommunityMenu,
  [TOGGLE_SHOW_COMMUNITY_SELECT_MODAL]: toggleShowCommunitySelectModal,
  [TOGGLE_MENTIONS_MODAL]: toggleMentionsModal
});
